// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3N37s","calendarButtons":"ClockData_calendarButtons__17rVw"};